import React from 'react';

const LogoutIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M5.2962 4.446C5.2962 1.995 7.356 0 9.88764 0H14.9199C17.4454 0 19.5 1.99 19.5 4.436V15.552C19.5 18.004 17.4413 20 14.9096 20H9.87731C7.35187 20 5.2962 18.009 5.2962 15.562V14.622V4.446Z"
        fill="currentColor"
      />
      <path
        d="M14.0374 9.45406L11.0695 6.54506C10.7627 6.24506 10.2691 6.24506 9.96338 6.54706C9.65867 6.84906 9.65968 7.33606 9.96541 7.63606L11.5905 9.22906H1.2821C0.85042 9.22906 0.5 9.57406 0.5 10.0001C0.5 10.4251 0.85042 10.7691 1.2821 10.7691H11.5905L9.96541 12.3631C9.65968 12.6631 9.65867 13.1501 9.96338 13.4521C10.1168 13.6031 10.3168 13.6791 10.518 13.6791C10.717 13.6791 10.9171 13.6031 11.0695 13.4541L14.0374 10.5451C14.1847 10.4001 14.268 10.2041 14.268 10.0001C14.268 9.79506 14.1847 9.59906 14.0374 9.45406Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default LogoutIcon;
